import { createClient, groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryBundleImage = {
  async bundleImage(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ARTICLES,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = createClient(AppSettings.sanityConfigByLang(lang))
    client.config({ ...config, useCdn: cdn })

    const data = await client.fetch(
      groq`*[_type=="sanity.imageAsset" && title == "Bundle" ][0] {  
      ...       
      }`,
    )

    return data
  },
}
